import Flickity from 'flickity';
import flickityFade from 'flickity-fade';
import { gsap, ScrollTrigger } from '../global/gsap';

const initHomeHero = (section) => {
    const root = document.documentElement;
    const header = document.querySelector('.js-header');
    const slider = section.querySelector('.js-home-hero-slider');
    const slides = section.querySelectorAll('.js-cell');
    const slideCount = slides.length;
    const overlayTriggers = section.querySelectorAll('.js-overlay-trigger');
    const overlayClose = document.querySelector('.overlay .js-overlay-trigger');
    const controls = section.querySelectorAll('.js-control');

    const progress = section.querySelector('.js-progress');
    let isPaused = false;
    let overlayActive = false;
    const duration = 7;
    const interval = 10;
    let percentTime;
    let step;
    let tick;

    const statementBg = section.querySelector('.js-home-hero-bg');
    const statementSection = section.querySelector('.js-home-hero-statement');

    // reusable function for toggle active/inactive arrows
    const toggleControls = (currentSlide) => {
        if (currentSlide === 0) {
            controls[0].classList.add('inactive');
            controls[1].classList.remove('inactive');
        } else if (currentSlide === slideCount - 1) {
            controls[0].classList.remove('inactive');
            controls[1].classList.add('inactive');
        } else {
            controls[0].classList.remove('inactive');
            controls[1].classList.remove('inactive');
        }
    };

    // Theme selector function
    const toggleTheme = (theme) => {
        if (theme) {
            root.style.setProperty('--theme', `${theme}`);
            header.style.setProperty('--theme', `${theme}`);
        } else {
            root.style.setProperty('--theme', 'var(--color-red)');
            header.style.setProperty('--theme', 'var(--color-red)');
        }
    };

    // Set up slider
    const flkty = new Flickity(slider, {
        cellSelector: '.js-cell',
        prevNextButtons: false,
        wrapAround: false,
        pageDots: false,
        draggable: false,
        fade: true,
        autoplay: false,
        pauseAutoPlayOnHover: false,
    });

    // Slider controls
    controls.forEach((control) => {
        const { dir } = control.dataset;
        control.addEventListener('click', () => {
            if (dir === 'prev') {
                flkty.previous();
            } else {
                flkty.next();
            }
        });
    });

    flkty.on('change', (index) => {
        const { theme } = slides[index].dataset;
        toggleControls(index);
        toggleTheme(theme);
        resetProgressbar();
        startProgressbar();
    });

    // Progress update etc
    const startProgressbar = () => {
        resetProgressbar();
        percentTime = 0;
        isPaused = false;
        tick = window.setInterval(increase, interval);
    };

    const increase = () => {
        if (!isPaused && !overlayActive) {
            step = (duration * 1000) / interval;
            percentTime += 100 / step;
            progress.style.setProperty('--progress', percentTime);
            if (percentTime >= 100) {
                if (flkty.selectedIndex === slides.length - 1) {
                    flkty.select(0);
                } else {
                    flkty.next();
                }
                startProgressbar();
            }
        }
    };

    const resetProgressbar = () => {
        progress.style.setProperty('--progress', 0);
        clearTimeout(tick);
    };

    startProgressbar();

    // Set up overlay triggers etc
    overlayTriggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
            isPaused = true;
        });
        trigger.addEventListener('mouseleave', () => {
            isPaused = false;
        });
        trigger.addEventListener('click', () => {
            overlayActive = true;
        });
    });

    overlayClose.addEventListener('click', () => {
        overlayActive = false;
    });

    // Set inactive classes on load & colour theme
    toggleControls(0);
    toggleTheme(slides[0].dataset.theme);

    // Timelines for overlapping content etc
    const statementTl = gsap.timeline({
        scrollTrigger: {
            trigger: statementSection,
            start: 'top 80%',
            end: 'top 50%',
            scrub: 1.05,
            onEnter: () => {
                isPaused = true;
                toggleTheme('var(--color-white)');
            },
            onLeaveBack: () => {
                isPaused = false;
                toggleTheme(slides[flkty.selectedIndex].dataset.theme);
            }
        },
    });

    statementTl.to(statementBg, {
        opacity: 1,
    });

    const hideSectionTl = gsap.timeline({
        scrollTrigger: {
            trigger: statementSection,
            endTrigger: section.nextElementSibling,
            start: 'bottom bottom',
            end: 'top top',
            // pin: true,
            onLeave: () => {
                gsap.to(section, {
                    autoAlpha: 0
                });
            },
            onEnterBack: () => {
                gsap.to(section, {
                    autoAlpha: 1
                });
            }
        }
    });
};

export default initHomeHero;
